export const VERIFY_USER = "VERIFY_USER";
export const CLEAR_VERIFICATION_DATA = "CLEAR_VERIFICATION_DATA";
